import $ from 'jquery'
window.$ = window.jquery = window.jQuery = $;
globalThis.$ = globalThis.jQuery = $;

import '@popperjs/core'
import moment from 'moment'
import Noty from 'noty'
import 'jquery.nicescroll'
import 'jszip'
import 'pdfmake'
require('datatables.net');
require('datatables.net-bs4');

require('datatables.net-buttons');
require('datatables.net-buttons-bs4');

require('datatables.net-responsive');
require('datatables.net-responsive-bs4');
require('owl.carousel')
import '../fileuploads'

import summernote from 'summernote/dist/summernote-bs5'
window.summernote = summernote;

import selectpicker from 'bootstrap-select'
import 'uuid'
import I18n from 'i18n-js'
(require('smartwizard/dist/js/jquery.smartWizard.js'))(window, $);
import Porthole from 'porthole-proxy'
require('jquery.flot.current')
require('jQuery.print')
import 'hammerjs'
require('jquery-ui/ui/widget');
require('jquery-ui/ui/plugin');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/widgets/sortable'); /* For the ranking df element */
require('jquery-ui/ui/disable-selection'); /* For the ranking df element */
const draggable = require('jquery-ui/ui/widgets/draggable');

// Code highlighting libs
import hljs from 'highlight.js/lib/core';
import html from 'highlight.js/lib/languages/xml';
import plaintext from 'highlight.js/lib/languages/plaintext';

window.Noty = Noty;
window.moment = moment;
window.I18n = I18n;
window.Porthole = Porthole;
window.Noty = Noty
window.spicker = window.selectpicker = selectpicker;
window.hljs = hljs;
window.draggable = draggable;


// Code highlighting init
hljs.registerLanguage('html', html);
hljs.registerLanguage('plaintext', plaintext);
hljs.highlightAll();

//needed for df/fb validation
function initSelectPicker(selector) {$(selector).selectpicker('refresh');}
function destroySelectPicker(selector) {$(selector).selectpicker('destroy');}
function refreshSelectPicker(selector) {$(selector).selectpicker();}
window.refreshSelectPicker = refreshSelectPicker;
window.destroySelectPicker = destroySelectPicker;
window.initSelectPicker = initSelectPicker;
import $ from 'jquery'
window.$ = window.jquery = window.jQuery = $;
globalThis.$ = globalThis.jQuery = $;

import '@popperjs/core'
import moment from 'moment'
import Noty from 'noty'
import 'jquery.nicescroll'
import 'jszip'
import 'pdfmake'
require('datatables.net');
require('datatables.net-bs4');

require('datatables.net-buttons');
require('datatables.net-buttons-bs4');

require('datatables.net-responsive');
require('datatables.net-responsive-bs4');
require('owl.carousel')
import '../fileuploads'

import summernote from 'summernote/dist/summernote-bs5'
window.summernote = summernote;

import selectpicker from 'bootstrap-select'
import 'uuid'
import I18n from 'i18n-js'
(require('smartwizard/dist/js/jquery.smartWizard.js'))(window, $);
import Porthole from 'porthole-proxy'
require('jquery.flot.current')
require('jQuery.print')
import 'hammerjs'
require('jquery-ui/ui/widget');
require('jquery-ui/ui/plugin');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/widgets/sortable'); /* For the ranking df element */
require('jquery-ui/ui/disable-selection'); /* For the ranking df element */
const draggable = require('jquery-ui/ui/widgets/draggable');

// Code highlighting libs
import hljs from 'highlight.js/lib/core';
import html from 'highlight.js/lib/languages/xml';
import plaintext from 'highlight.js/lib/languages/plaintext';

window.Noty = Noty;
window.moment = moment;
window.I18n = I18n;
window.Porthole = Porthole;
window.Noty = Noty
window.spicker = window.selectpicker = selectpicker;
window.hljs = hljs;
window.draggable = draggable;


// Code highlighting init
hljs.registerLanguage('html', html);
hljs.registerLanguage('plaintext', plaintext);
hljs.highlightAll();

//needed for df/fb validation
function initSelectPicker(selector) {$(selector).selectpicker('refresh');}
function destroySelectPicker(selector) {$(selector).selectpicker('destroy');}
function refreshSelectPicker(selector) {$(selector).selectpicker();}
window.refreshSelectPicker = refreshSelectPicker;
window.destroySelectPicker = destroySelectPicker;
window.initSelectPicker = initSelectPicker;
